// AdditionalServicesOptions.js
import React from 'react';
import {FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Box} from '@mui/material';
import {useQuote} from "../../lib/contexts/QuoteContext";

const AdditionalServicesOptions = ({ mode }) => {
   const { specialHandling, setSpecialHandling, hazardousMaterials, setHazardousMaterials } = useQuote();
   
   const additionalServiceOptions = [
      { label: 'Lift Gate Service', value: 'lift gate service' },
      { label: 'Residential Service', value: 'residential service' },
      { label: 'Inside Pickup/Delivery', value: 'inside pickup/delivery' },
      { label: 'Appointment Needed', value: 'appointment needed' },
      { label: 'Weekend Service', value: 'weekend service' },
      { label: 'Storage', value: 'storage' },
      { label: 'Packaging', value: 'packaging' },
      { label: 'Cargo Insurance', value: 'cargo insurance' },
      { label: 'Customs Brokerage', value: 'customs brokerage' }
   ];
   
   
   const handleChange = (event) => {
      const { value, checked } = event.target;
      const newSpecialHandling = checked
         ? [...specialHandling, value]
         : specialHandling.filter(option => option !== value);
      setSpecialHandling(newSpecialHandling);
   };
   
   const handleHazardousMaterialsChange = (event) => {
      setHazardousMaterials(event.target.checked);
   };
   
   return (
      <FormControl component="fieldset" fullWidth>
         <FormLabel component="legend">Additional Services</FormLabel>
         <Box sx={{
            maxHeight: '200px',
            overflowY: 'auto'
         }}>
            {mode === "material" && (
               <FormControlLabel
                  control={<Checkbox checked={hazardousMaterials} onChange={handleHazardousMaterialsChange} />}
                  label="Contains Hazardous Materials"
               />
            )}
            {additionalServiceOptions.map(option => (
               <FormControlLabel
                  key={option.value}
                  control={<Checkbox checked={specialHandling.includes(option.value)} onChange={handleChange} value={option.value} />}
                  label={option.label}
               />
            ))}
         </Box>
      </FormControl>
   );
};

export default AdditionalServicesOptions;
